import { fetchApi } from '@/services/api-client';

const STUDENT_AIDES_PATH = '/student-aides';

export type AideOffToday = 'full_day' | 'morning_half' | 'afternoon_half';
export type StaffName = {
  id: string;
  name: string;
  nickname: string | null;
  photoUrl: string;
  /** Approved leave covering today; the leave type stays private. */
  offToday: AideOffToday | null;
};
export type StudentSupportStaff = { aides: StaffName[]; classAssistants: StaffName[] };
export type StudentAidePair = {
  studentId: string;
  studentName: string;
  gradeLevel: number | null;
  aideId: string;
  aideName: string;
  aideNickname: string | null;
  aidePhotoUrl: string;
  aideOffToday: AideOffToday | null;
};
export type MyAideStudent = { studentId: string; studentName: string; gradeLevel: number | null };

export const studentAidesApi = {
  supportStaff: (studentId: string) => fetchApi<StudentSupportStaff>(`/students/${studentId}/support-staff`),
  setAides: (studentId: string, userIds: string[]) =>
    fetchApi<StudentSupportStaff>(`/students/${studentId}/aides`, {
      method: 'PUT',
      body: JSON.stringify({ userIds }),
    }),
  list: () => fetchApi<StudentAidePair[]>(STUDENT_AIDES_PATH),
  mine: () => fetchApi<MyAideStudent[]>(`${STUDENT_AIDES_PATH}/mine`),
};
